import { Pipe, PipeTransform } from '@angular/core';
import { Labels } from '../../shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { TranslateService } from '@ngx-translate/core';
import { Utilities } from '../../shared/utilities/utilities';

@Pipe({
    name: 'slotTimeFormatter',
    standalone: false
})
export class SlotTimeFormatter implements PipeTransform {
    btnFormat: ButtonValue;
    constructor(public translateService: TranslateService) {
    }

    transform(data: any): any {
        // let timeZoneDate = new Date(data);
        // let SlotDate = new Date(timeZoneDate.getTime() + (timeZoneDate.getTimezoneOffset() * 60000));
        const SlotDate = Utilities.parseDateString(data);
        let amPm = Labels[Labels.slotTimeAM];
        let hrs = SlotDate.getHours();
        let mins = ('0' + SlotDate.getMinutes()).slice(-2);
        if (hrs >= 12) {
          hrs = hrs === 12 ? 12 : hrs - 12;
          amPm = Labels[Labels.slotTimePM];
        }
        if(hrs == 0){
            hrs=12;
        }
        const slotTime = hrs + '.' + mins + ' ' + this.translateService.instant(amPm);
        return slotTime;
    }



}


